// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeSunbit_titleIcon__mC6_b","inputPhoneContainer":"ViewChargeSunbit_inputPhoneContainer__fG3-w"};